// from Jpos Spec
export enum JposConst {
  JPOS_E_CLOSED = 'JPOS_E_CLOSED',
  JPOS_E_CLAIMED = 'JPOS_E_CLAIMED',
  JPOS_E_NOTCLAIMED = 'JPOS_E_NOTCLAIMED',
  JPOS_E_NOSERVICE = 'JPOS_E_NOSERVICE',
  JPOS_E_DISABLED = 'JPOS_E_DISABLED',
  JPOS_E_ILLEGAL = 'JPOS_E_ILLEGAL',
  JPOS_E_NOHARDWARE = 'JPOS_E_NOHARDWARE',
  JPOS_E_OFFLINE = 'JPOS_E_OFFLINE',
  JPOS_E_NOEXIST = 'JPOS_E_NOEXIST',
  JPOS_E_EXISTS = 'JPOS_E_EXISTS',
  JPOS_E_FAILURE = 'JPOS_E_FAILURE',
  JPOS_E_TIMEOUT = 'JPOS_E_TIMEOUT',
  JPOS_E_BUSY = 'JPOS_E_BUSY',
  JPOS_E_EXTENDED = 'JPOS_E_EXTENDED',
  JPOS_E_DEPRECATED = 'JPOS_E_DEPRECATED',
  JPOS_ESTATS_ERROR = 'JPOS_ESTATS_ERROR',
  JPOS_EFIRMWARE_BAD_FILE = 'JPOS_EFIRMWARE_BAD_FILE',
  JPOS_ESTATS_DEPENDENCY = 'JPOS_ESTATS_DEPENDENCY',
  JPOS_EL_OUTPUT = 'JPOS_EL_OUTPUT',
  JPOS_EL_INPUT = 'JPOS_EL_INPUT',
  JPOS_EL_INPUT_DATA = 'JPOS_EL_INPUT_DATA',
  JPOS_ER_RETRY = 'JPOS_ER_RETRY',
  JPOS_ER_CLEAR = 'JPOS_ER_CLEAR',
  JPOS_ER_CONTINUEINPUT = 'JPOS_ER_CONTINUEINPUT',
  JPOS_SUE_POWER_ONLINE = 'JPOS_SUE_POWER_ONLINE',
  JPOS_SUE_POWER_OFF = 'JPOS_SUE_POWER_OFF',
  JPOS_SUE_POWER_OFFLINE = 'JPOS_SUE_POWER_OFFLINE',
  JPOS_SUE_POWER_OFF_OFFLINE = 'JPOS_SUE_POWER_OFF_OFFLINE',
  JPOS_SUE_UF_PROGRESS = 'JPOS_SUE_UF_PROGRESS',
  JPOS_SUE_UF_COMPLETE = 'JPOS_SUE_UF_COMPLETE',
  JPOS_SUE_UF_FAILED_DEV_OK = 'JPOS_SUE_UF_FAILED_DEV_OK',
  JPOS_SUE_UF_FAILED_DEV_UNRECOVERABLE = 'JPOS_SUE_UF_FAILED_DEV_UNRECOVERABLE',
  JPOS_SUE_UF_FAILED_DEV_NEEDS_FIRMWARE = 'JPOS_SUE_UF_FAILED_DEV_NEEDS_FIRMWARE',
  JPOS_SUE_UF_FAILED_DEV_UNKNOWN = 'JPOS_SUE_UF_FAILED_DEV_UNKNOWN',
  JPOS_SUE_UF_COMPLETE_DEV_NOT_RESTORED = 'JPOS_SUE_UF_COMPLETE_DEV_NOT_RESTORED',
  PTR_SUE_COVER_OPEN = 'PTR_SUE_COVER_OPEN',
  PTR_SUE_COVER_OK = 'PTR_SUE_COVER_OK',
  PTR_SUE_JRN_EMPTY = 'PTR_SUE_JRN_EMPTY',
  PTR_SUE_JRN_NEAREMPTY = 'PTR_SUE_JRN_NEAREMPTY',
  PTR_SUE_JRN_PAPEROK = 'PTR_SUE_JRN_PAPEROK',
  PTR_SUE_REC_EMPTY = 'PTR_SUE_REC_EMPTY',
  PTR_SUE_REC_NEAREMPTY = 'PTR_SUE_REC_NEAREMPTY',
  PTR_SUE_REC_PAPEROK = 'PTR_SUE_REC_PAPEROK',
  PTR_SUE_SLP_EMPTY = 'PTR_SUE_SLP_EMPTY',
  PTR_SUE_SLP_NEAREMPTY = 'PTR_SUE_SLP_NEAREMPTY',
  PTR_SUE_SLP_PAPEROK = 'PTR_SUE_SLP_PAPEROK',
  PTR_SUE_JRN_CARTRIDGE_EMPTY = 'PTR_SUE_JRN_CARTRIDGE_EMPTY',
  PTR_SUE_JRN_CARTRIDGE_NEAREMPTY = 'PTR_SUE_JRN_CARTRIDGE_NEAREMPTY',
  PTR_SUE_JRN_HEAD_CLEANING = 'PTR_SUE_JRN_HEAD_CLEANING',
  PTR_SUE_JRN_CARTRIDGE_OK = 'PTR_SUE_JRN_CARTRIDGE_OK',
  PTR_SUE_REC_CARTRIDGE_EMPTY = 'PTR_SUE_REC_CARTRIDGE_EMPTY',
  PTR_SUE_REC_CARTRIDGE_NEAREMPTY = 'PTR_SUE_REC_CARTRIDGE_NEAREMPTY',
  PTR_SUE_REC_HEAD_CLEANING = 'PTR_SUE_REC_HEAD_CLEANING',
  PTR_SUE_REC_CARTRIDGE_OK = 'PTR_SUE_REC_CARTRIDGE_OK',
  PTR_SUE_SLP_CARTRIDGE_EMPTY = 'PTR_SUE_SLP_CARTRIDGE_EMPTY',
  PTR_SUE_SLP_CARTRIDGE_NEAREMPTY = 'PTR_SUE_SLP_CARTRIDGE_NEAREMPTY',
  PTR_SUE_SLP_HEAD_CLEANING = 'PTR_SUE_SLP_HEAD_CLEANING',
  PTR_SUE_SLP_CARTRIDGE_OK = 'PTR_SUE_SLP_CARTRIDGE_OK',
  PTR_SUE_IDLE = 'PTR_SUE_IDLE',
  PTR_SUE_JRN_COVER_OPEN = 'PTR_SUE_JRN_COVER_OPEN',
  PTR_SUE_JRN_COVER_OK = 'PTR_SUE_JRN_COVER_OK',
  PTR_SUE_REC_COVER_OPEN = 'PTR_SUE_REC_COVER_OPEN',
  PTR_SUE_REC_COVER_OK = 'PTR_SUE_REC_COVER_OK',
  PTR_SUE_SLP_COVER_OPEN = 'PTR_SUE_SLP_COVER_OPEN',
  PTR_SUE_SLP_COVER_OK = 'PTR_SUE_SLP_COVER_OK',
  JPOS_EPTR_COVER_OPEN = 'JPOS_EPTR_COVER_OPEN',
  JPOS_EPTR_JRN_EMPTY = 'JPOS_EPTR_JRN_EMPTY',
  JPOS_EPTR_REC_EMPTY = 'JPOS_EPTR_REC_EMPTY',
  JPOS_EPTR_SLP_EMPTY = 'JPOS_EPTR_SLP_EMPTY',
  JPOS_EPTR_SLP_FORM = 'JPOS_EPTR_SLP_FORM',
  JPOS_EPTR_TOOBIG = 'JPOS_EPTR_TOOBIG',
  JPOS_EPTR_BADFORMAT = 'JPOS_EPTR_BADFORMAT',
  JPOS_EPTR_JRN_CARTRIDGE_REMOVED = 'JPOS_EPTR_JRN_CARTRIDGE_REMOVED',
  JPOS_EPTR_JRN_CARTRIDGE_EMPTY = 'JPOS_EPTR_JRN_CARTRIDGE_EMPTY',
  JPOS_EPTR_JRN_HEAD_CLEANING = 'JPOS_EPTR_JRN_HEAD_CLEANING',
  JPOS_EPTR_REC_CARTRIDGE_REMOVED = 'JPOS_EPTR_REC_CARTRIDGE_REMOVED',
  JPOS_EPTR_REC_CARTRIDGE_EMPTY = 'JPOS_EPTR_REC_CARTRIDGE_EMPTY',
  JPOS_EPTR_REC_HEAD_CLEANING = 'JPOS_EPTR_REC_HEAD_CLEANING',
  JPOS_EPTR_SLP_CARTRIDGE_REMOVED = 'JPOS_EPTR_SLP_CARTRIDGE_REMOVED',
  JPOS_EPTR_SLP_CARTRIDGE_EMPTY = 'JPOS_EPTR_SLP_CARTRIDGE_EMPTY',
  JPOS_EPTR_SLP_HEAD_CLEANING = 'JPOS_EPTR_SLP_HEAD_CLEANING',
  SCL_SUE_STABLE_WEIGHT = 'SCL_SUE_STABLE_WEIGHT',
  SCL_SUE_WEIGHT_UNSTABLE = 'SCL_SUE_WEIGHT_UNSTABLE',
  SCL_SUE_WEIGHT_ZERO = 'SCL_SUE_WEIGHT_ZERO',
  SCL_SUE_WEIGHT_OVERWEIGHT = 'SCL_SUE_WEIGHT_OVERWEIGHT',
  SCL_SUE_NOT_READY = 'SCL_SUE_NOT_READY',
  SCL_SUE_WEIGHT_UNDER_ZERO = 'SCL_SUE_WEIGHT_UNDER_ZERO',
  JPOS_ESCAL_OVERWEIGHT = 'JPOS_ESCAL_OVERWEIGHT',
  JPOS_ESCAL_UNDER_ZERO = 'JPOS_ESCAL_UNDER_ZERO',
  JPOS_ESCAL_SAME_WEIGHT = 'JPOS_ESCAL_SAME_WEIGHT',
  JPOS_EMICR_NOCHECK = 'JPOS_EMICR_NOCHECK',
  JPOS_EMICR_CHECK = 'JPOS_EMICR_CHECK',
  JPOS_EMICR_BADDATA = 'JPOS_EMICR_BADDATA',
  JPOS_EMICR_NODATA = 'JPOS_EMICR_NODATA',
  JPOS_EMICR_BADSIZE = 'JPOS_EMICR_BADSIZE',
  JPOS_EMICR_JAM = 'JPOS_EMICR_JAM',
  JPOS_EMICR_CHECKDIGIT = 'JPOS_EMICR_CHECKDIGIT',
  JPOS_EMICR_COVEROPEN = 'JPOS_EMICR_COVEROPEN',
  JPOS_CASH_SUE_DRAWERCLOSED = 'JPOS_CASH_SUE_DRAWERCLOSED',
  JPOS_CASH_SUE_DRAWEROPEN = 'JPOS_CASH_SUE_DRAWEROPEN',
  JPOS_SCAL_SUE_WEIGHT_UNSTABLE = 'JPOS_SCAL_SUE_WEIGHT_UNSTABLE',
  JPOS_SCAL_SUE_WEIGHT_OVERWEIGHT = 'JPOS_SCAL_SUE_WEIGHT_OVERWEIGHT',
  JPOS_SCAL_SUE_WEIGHT_UNDERWEIGHT = 'JPOS_SCAL_SUE_WEIGHT_UNDERWEIGHT',
  JPOS_SCAL_SUE_NOT_READY = 'JPOS_SCAL_SUE_NOT_READY',
  JPOS_SCAL_SUE_WEIGHT_UNDER_ZERO = 'JPOS_SCAL_SUE_WEIGHT_UNDER_ZERO',
}
